<template>
    <section class="forgot-password">
        <header>
            <h2>Forgot your password?</h2>

            <p>Enter your email address below and we'll get you back on track.</p>
        </header>

        <div class="success-card" v-if="requestStatus">
            <img src="@/assets/icons/ic_error.png" class="icon">
            <p>Email Sent.</p>
        </div>

        <div class="error-card" v-if="error">
            <img src="@/assets/icons/ic_error.png" class="icon">

            <p>{{ error }}</p>
        </div>

        <form @submit.prevent="requestResetLink()">
            <label>
                Email Address

                <input
                    type="email"
                    placeholder="Email@info.com"
                    required
                    v-model="forgotPassword.email"
                >
            </label>

            <button :disabled="loading">
                {{ loading ? 'Loading...' : 'Request Reset Link' }}
            </button>

            <a @click="$router.push('/')">
                Back to Sign In
            </a>
        </form>
    </section>
</template>

<script>
import Form from '@/class/Form'
import { mapFields } from 'vuex-map-fields'

export default {
	beforeRouteLeave (to, from, next) {
		this.clearPage()

		next()
	},

	computed: {
		...mapFields([
			'forgotPassword',
			'loading',
			'error',
			'requestStatus'
		])
	},

	methods: {
		/* Request Reset Link */
		async requestResetLink () {
			if (this.loading) return

			const { form, validated } = await this.validate()

			if (validated) {
				const formData = new FormData()
				formData.append('email', form.get('email'))

				this.$store.dispatch('requestReset', { form: formData, router: this.$router })
			}
		},

		validate () {
			const form = new Form(this.forgotPassword)

			const data = {
				form,
				validated: true
			}

			if (!form.isValidEmail('email')) {
				data.validated = false
				this.error = 'Please enter valid Email.'
			}

			return data
		},

		/* Before Route Leave */
		clearPage () {
			this.error = ''

			this.forgotPassword = {
				email: ''
			}

			this.requestStatus = false
		}
	}
}
</script>

<style lang="scss" scoped>
.forgot-password {
    height: 100%;
    width: 100%;
    color: #fff;

    .error-card {
        background-color: $danger;
        padding: 10px;
        color: #fff;
        border-radius: 5px;
        margin-bottom: 20px;
        @include flex-row(flex-start, center);

        p {
            margin-left: 10px;
            font-style: italic;
        }
    }

    .success-card {
        background-color: $success;
        padding: 10px;
        color: #fff;
        border-radius: 5px;
        margin-bottom: 20px;
        @include flex-row(flex-start, center);

        p {
            margin-left: 10px;
            font-style: italic;
        }
    }

    header {
        margin-bottom: 20px;

        h2, p {
            text-align: center;
            margin-bottom: 15px;
        }
    }

    form {
        label {
            color: #fff;
            margin-bottom: 20px;
            display: block;
            width: 100%;
            cursor: pointer;

            input {
                display: block;
                width: 100%;
                margin-top: 15px;
                padding: 10px 15px;
                font-weight: 400;

                &::placeholder {
                    font-weight: 400;
                    color: #95989a;
                }
            }
        }

        a {
            color: #fff;
            margin: 10px 0;
            display: inline-block;
            transition: 0.3s;

            &:hover {
                text-decoration: underline;
            }
        }

        button {
            border: 2px solid #fff;
            color: #fff;
            font-size: 18px;
            margin: 10px 0;
            background-color: transparent;
            width: 100%;
            transition: 0.3s;
            padding: 10px 0;

            &:hover {
                background-color: $primary;
                border-color: $primary;
            }
        }
    }
}
</style>
